export default "../../src/img/tex2.png";